import { formatarInteiro } from '@/lib/formato';
import { primeiraMaiuscula } from '@/lib/texto';

/**
 * O texto que as telas do módulo 03 compõem (p.23).
 *
 * `explicarFalha` devolve `erro` em minúscula e sem ponto, porque ele é a
 * metade de uma frase que a tela monta. Quando ele aparece SOZINHO numa linha
 * — a caixa de recusa —, a tela fecha a frase: maiúscula e ponto final. Sem
 * isso a caixa mostrava "sua sessão expirou" solto, com cara de pedaço.
 */
export function fraseDoErro(erro: string): string {
  const texto = primeiraMaiuscula(erro.trim());
  return /[.?]$/.test(texto) ? texto : `${texto}.`;
}

/**
 * Número e substantivo concordando: "1 divergência aberta", "2 divergências
 * abertas". O "(s)" deixa o texto com cara de sistema, e a p.23 pede voz de
 * gente.
 */
export function contar(quantidade: number, singular: string, plural: string): string {
  return `${formatarInteiro(quantidade)} ${quantidade === 1 ? singular : plural}`;
}

/**
 * O CÓDIGO QUE SAI DO NOME (31/10/2026): "Bomba hidráulica" vira
 * BOMBA-HIDRAULICA, no formato que o banco cobra (`^[A-Z0-9][A-Z0-9-]*$`).
 * Quem cadastra a causa escreve o nome e o código vem junto; quem quer outro
 * código escreve por cima.
 */
export function codigoDoNome(nome: string): string {
  return nome
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
